import CircleFilled from "@/assets/icons/CircleFilled";
import Remove from "@/assets/icons/Remove";
import { Radio, RadioGroup, RadioIcon, RadioIndicator, RadioLabel } from "@/components/ui/radio";
import { T } from "@transifex/react";
import { Pressable } from "react-native";

type LicensePlateRadioProps = {
  selectedValue: string;
  onValueChange: (newValue: string) => void;
  plates: { id: string; plate: string }[];
  onDelete: (id: string) => void;
};

export function LicensePlateRadio({ selectedValue, onValueChange, plates, onDelete }: Readonly<LicensePlateRadioProps>) {
  return (
    <RadioGroup className="gap-[8px]" onChange={onValueChange} value={selectedValue}>
      {plates.map(({ id, plate }) => (
        <Radio
          className={`border gap-[12px] px-[16px] py-[20px] rounded-[6px] ${
            selectedValue === plate ? "bg-primary-200 border-primary-800" : "bg-background-100 border-outline-300"
          }`}
          key={id}
          value={plate}
        >
          <RadioIndicator className="h-[24px] border-[1px] border-primary-800 w-[24px]">
            <RadioIcon as={CircleFilled} className="h-[12px] text-primary-800 w-[12px]" />
          </RadioIndicator>
          <RadioLabel className="flex-1 font-[400] leading-[22px] text-[16px] text-typography-900">{plate}</RadioLabel>
          <Pressable data-test-id={`delete-button-${id}`} onPress={() => onDelete(plate)}>
            <Remove />
          </Pressable>
        </Radio>
      ))}
      <Radio
        value="NEW"
        className={`border gap-[12px] px-[16px] py-[20px] rounded-[6px] ${
          selectedValue === "NEW" ? "bg-primary-200 border-primary-800" : "bg-background-100 border-outline-300"
        }`}
      >
        <RadioIndicator className="h-[24px] border-[1px] border-primary-800 w-[24px]">
          <RadioIcon as={CircleFilled} className="h-[12px] text-primary-800 w-[12px]" />
        </RadioIndicator>
        <RadioLabel className="font-[400] leading-[22px] text-[16px] text-typography-900">
          <T _str="Enter a new plate" />
        </RadioLabel>
      </Radio>
    </RadioGroup>
  );
}
